export const ASSIGNEE_PICKER_COMPANY = 'company';
export const ASSIGNEE_PICKER_ROLE = 'role';
export const ASSIGNEE_PICKER_USER = 'user';
export const DEFAULT_OPTIONS_ORDER = [ASSIGNEE_PICKER_USER, ASSIGNEE_PICKER_COMPANY, ASSIGNEE_PICKER_ROLE];
export const DEFAULT_VALUE_KEY = 'id';
export const DEFAULT_USERS_STATUS_FILTER = ['active', 'pending', 'disabled', 'deleted'];
//# sourceMappingURL=consts.js.map